import { useEffect } from 'react';

import { SearchOpenEvent } from '../../../hooks/use-search-input-field';

export type UseSearchShortcutsParams = {
    isOpen: boolean;
    onOpen: (event: SearchOpenEvent) => void;
    onClose: () => void;
};

const isTypingTarget = (target: EventTarget | null) => {
    const element = target as HTMLElement | null;

    return !!element && (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.isContentEditable);
};

/** "/" opens the header search (not while typing in a field), Escape closes it */
export const useSearchShortcuts = ({ isOpen, onOpen, onClose }: UseSearchShortcutsParams) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();

                return;
            }
            if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey || isTypingTarget(event.target)) {
                return;
            }
            onOpen(event);
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onOpen, onClose]);
};
